<template>
	<div class="gb-page blog-index-page">
		<HeadNav selectedLanguage="en" page="blog" />

		<main id="maincontent" class="site-main">
			<section class="blog-header">
				<h1>GB WhatsApp Blog</h1>
				<p>
					Read the latest GB WhatsApp guides, updates, troubleshooting tips, installation help, backup
					solutions, and useful information for Android users.
				</p>
			</section>

			<section class="blog-list-row" aria-label="GB WhatsApp blog posts">
				<a v-for="article in articles" :key="article.name" :href="article.url" class="blog-list-item">
					<div class="blog-list-img">
						<img :src="article.poster" :alt="article.title" />
					</div>
					<div class="blog-list-content">
						<h2 class="blog-list-title">{{ article.title }}</h2>
						<div class="blog-list-descript">{{ article.desc }}</div>
						<div class="blog-list-date">{{ article.date }}</div>
					</div>
				</a>
			</section>
		</main>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/blog/blogspc.scss'
import blogDoc from '@/documents/blogs.js'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'Blogs',
	components: {
		HeadNav,
	},
	data() {
		return {
			articles: blogDoc.bloglist.en,
		}
	},
}
</script>

<style lang="scss" scoped>
.site-main {
	width: min(980px, 88vw);
	margin: 0 auto;
	padding: 1px 0 54px;
}

.blog-list-img img {
	display: block;
	width: 100%;
	aspect-ratio: 16 / 9;
	object-fit: cover;
	border-radius: 6px;
}

.blog-list-item {
	text-decoration: none;
	color: inherit;
}

@media (max-width: 768px) {
	.site-main {
		width: min(100% - 32px, 980px);
	}
}
</style>
